import {
    UPDATE_BATCH_ROWS, UPDATE_SELECTED_BATCH, UPDATE_STUDENT_ROWS, UPDATE_SELECTED_STUDENT, GET_CALCULATE, GET_NONSTUDENT, GET_SUMMARY_CALCULATE,
    UPDATE_NON_STUDENT_TAB, UPDATE_USER_DETAILS, RESET_STATE,UPDATE_EXCHANGE_RATES,GET_PARKING_BATCHES,GET_PARKING_BATCH_DETAIL,POST_PARKING_BATCH,INITIATE_MANUAL_PARKING_REFUND,SET_BATCH_TYPE_FILTER,
    FETCH_PARKING_BATCHES,FETCH_PARKING_BATCHES_SUCCESS,FETCH_PARKING_BATCHES_ERROR,FETCH_PARKING_BATCH_LINE_ITEMS,FETCH_PARKING_BATCH_LINE_ITEMS_SUCCESS,FETCH_PARKING_BATCH_LINE_ITEMS_ERROR,
    POST_PARKING_BATCH_SUCCESS,POST_PARKING_BATCH_ERROR,INITIATE_PARKING_REFUND,INITIATE_PARKING_REFUND_SUCCESS,INITIATE_PARKING_REFUND_ERROR
} from './types'

const initialState = {
    userDetails: {},
    exchangeRates:{
        getExchangeRangeDetails:{},
        getCurrencyConfiguration:{}
    },
    batch: {
        batchRows: [],
        selectedBatch: {}
    },
    student: {
        studentRows: [],
        selectedStudentRow: {}
    },
    courseTable: [], // docsum
    summaryTable: [],
    nonStudent: {
        nonstudentRows: [],
        selectedNonStudentRow: {}
    },
    nonstudentTable: [],
    parkingBatches: [],
    parkingBatchDetail: {},
    parkingBatchSummary: null,
    parkingBatchLineItems: [],
    parkingBatchesLoading: false,
    parkingBatchLineItemsLoading: false,
    parkingBatchPostLoading: false,
    parkingRefundLoading: false,
    parkingBatchError: null,
    parkingLineItemsError: null,
    batchTypeFilter: 'All'
};

const batchReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case UPDATE_USER_DETAILS:
            return {
                ...state,
                userDetails: payload
            }
        case UPDATE_EXCHANGE_RATES:
            return {
                ...state,
                exchangeRates: payload
            }
        case UPDATE_BATCH_ROWS:
            return {
                ...state,
                batch: {
                    ...state.batch, batchRows: payload
                }
            }
        case UPDATE_SELECTED_BATCH:
            return {
                ...state,
                batch: {
                    ...state.batch, selectedBatch: payload
                }
            }
        case UPDATE_STUDENT_ROWS:
            return {
                ...state,
                student: {
                    ...state.student, studentRows: payload
                }
            }
        case UPDATE_SELECTED_STUDENT:
            return {
                ...state,
                student: {
                    ...state.student, selectedStudentRow: payload
                }
            }
        case GET_CALCULATE:
            return {
                ...state,
                courseTable: [...payload]
            };
        case GET_NONSTUDENT:
            return {
                ...state,
                nonstudentTable: [...payload]
            };
        case GET_SUMMARY_CALCULATE:
            return {
                ...state,
                summaryTable: [...payload]
            };
        case UPDATE_NON_STUDENT_TAB:
            const { id, value } = payload
            return {
                ...state,
                nonStudent: {
                    ...state.nonStudent, [id]: value
                }
            }
        case RESET_STATE:
            return {
                ...state,
                ...initialState
            }
        case GET_PARKING_BATCHES:
            return {
                ...state,
                parkingBatches: payload
            }
        case GET_PARKING_BATCH_DETAIL:
            return {
                ...state,
                parkingBatchDetail: payload
            }
        case SET_BATCH_TYPE_FILTER:
            return {
                ...state,
                batchTypeFilter: payload
            }
        case FETCH_PARKING_BATCHES:
            return {
                ...state,
                parkingBatchesLoading: true,
                parkingBatchError: null
            }
        case FETCH_PARKING_BATCHES_SUCCESS:
            return {
                ...state,
                parkingBatchSummary: payload,
                parkingBatchesLoading: false
            }
        case FETCH_PARKING_BATCHES_ERROR:
            return {
                ...state,
                parkingBatchError: payload,
                parkingBatchesLoading: false
            }
        case FETCH_PARKING_BATCH_LINE_ITEMS:
            return {
                ...state,
                parkingBatchLineItemsLoading: true,
                parkingLineItemsError: null
            }
        case FETCH_PARKING_BATCH_LINE_ITEMS_SUCCESS:
            return {
                ...state,
                parkingBatchLineItems: payload || [],
                parkingBatchLineItemsLoading: false
            }
        case FETCH_PARKING_BATCH_LINE_ITEMS_ERROR:
            return {
                ...state,
                parkingLineItemsError: payload,
                parkingBatchLineItemsLoading: false
            }
        case POST_PARKING_BATCH:
            return {
                ...state,
                parkingBatchPostLoading: true
            }
        case POST_PARKING_BATCH_SUCCESS:
            return {
                ...state,
                parkingBatchPostLoading: false
            }
        case POST_PARKING_BATCH_ERROR:
            return {
                ...state,
                parkingBatchPostLoading: false,
                parkingBatchError: payload
            }
        case INITIATE_PARKING_REFUND:
            return {
                ...state,
                parkingRefundLoading: true
            }
        case INITIATE_PARKING_REFUND_SUCCESS:
            return {
                ...state,
                parkingRefundLoading: false
            }
        case INITIATE_PARKING_REFUND_ERROR:
            return {
                ...state,
                parkingRefundLoading: false,
                parkingBatchError: payload
            }
        default:
            return state;
    }
};

export default batchReducer;